import { Table, TableCell, TableHeader } from "@tiptap/extension-table";
import { Node } from "@tiptap/core";

// Quebra de página: bloco atômico. No editor vira uma linha tracejada;
// no PDF (xhtml2pdf) força nova página via page-break-before / <pdf:nextpage>.
export const PageBreak = Node.create({
  name: "pageBreak",
  group: "block",
  atom: true,
  selectable: true,
  parseHTML() {
    return [{ tag: "div[data-page-break]" }];
  },
  renderHTML() {
    return ["div", { "data-page-break": "true", class: "page-break", style: "page-break-before: always;" }];
  },
  addCommands() {
    return {
      setPageBreak: () => ({ commands }) => commands.insertContent({ type: this.name }),
    };
  },
});

// Tabela com estilo de borda persistido (bordered | colored | none).
// A classe vai para o HTML salvo e é renderizada no PDF (xhtml2pdf).
export const DocTable = Table.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      borderStyle: {
        default: "bordered",
        parseHTML: (el) => el.getAttribute("data-border") || "bordered",
        renderHTML: (attrs) => ({
          "data-border": attrs.borderStyle || "bordered",
          class: `doc-table ${attrs.borderStyle || "bordered"}`,
        }),
      },
    };
  },
});

// Preserva a classe (ex.: "lbl") nas células ao serializar/reserializar.
const keepClass = {
  addAttributes() {
    return {
      ...this.parent?.(),
      class: {
        default: null,
        parseHTML: (el) => el.getAttribute("class"),
        renderHTML: (attrs) => (attrs.class ? { class: attrs.class } : {}),
      },
    };
  },
};

export const DocTableCell = TableCell.extend(keepClass);
export const DocTableHeader = TableHeader.extend(keepClass);
